import {
    ADD_REVENUE_DATA_REQUEST,
    ADD_REVENUE_DATA_SUCCESS,
    ADD_REVENUE_DATA_FAILURE
} from "../../../constants"

const initialState = {
    data: null,
    loading: false,
    error: null,
    type: null,
};

const addRevenueReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_REVENUE_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                type: action.fetch_type,
            };
        case ADD_REVENUE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                type: action.fetch_type,
                error: null,
            };
        case ADD_REVENUE_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                type: action.fetch_type,
                data: null,
            };
        default:
            return state;
    }
};

export default addRevenueReducer;
